export { default } from './AnimatedLink';
